<template>
  <modal ref="modal">
    <modal-title title="依頼物件絞り込み" />
    <modal-content-body>
      <danger-alert v-if="dataNotFound" message="該当する物件がありません" />
      <label class="col-form-label">物件名・棟名（部分一致）</label>
      <input type="text" class="form-control" :class="errors?.name ? 'is-invalid' : ''" v-model="name">
      <div class="invalid-feedback">{{ errors?.name?.[0] }}</div>
      <label class="col-form-label">物件名・棟名（カナ）（部分一致）</label>
      <input type="text" class="form-control" :class="errors?.name_kana ? 'is-invalid' : ''" v-model="name_kana">
      <div class="invalid-feedback">{{ errors?.name_kana?.[0] }}</div>
      <label class="col-form-label">住所 都道府県</label>
      <prefecture-select :class="errors?.prefecture_code ? 'is-invalid' : ''" :value="prefecture_code" :set-handler="setPrefecture" />
      <div class="invalid-feedback">{{ errors?.prefecture_code?.[0] }}</div>
      <label class="col-form-label">住所 市区町村（部分一致）</label>
      <input type="text" class="form-control" :class="errors?.address1 ? 'is-invalid' : ''" v-model="address1">
      <div class="invalid-feedback">{{ errors?.address1?.[0] }}</div>
    </modal-content-body>
    <modal-footer>
      <filter-button @click="doFilter" />
      <reset-button @click="doReset" />
      <cancel-button data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>

<script>
import Modal from '@/views/atoms/Modal'
import ModalTitle from '@/views/atoms/ModalTitle'
import ModalContentBody from '@/views/atoms/ModalContentBody'
import DangerAlert from '@/views/atoms/alerts/DangerAlert'
import PrefectureSelect from '@/views/atoms/inputs/PrefectureSelect'
import ModalFooter from "@/views/atoms/ModalFooter"
import FilterButton from '@/views/molecules/buttons/FilterButton'
import ResetButton from '@/views/molecules/buttons/ResetButton'
import CancelButton from '@/views/molecules/buttons/CancelButton'

export default {
  name: "BuildingFilterModal",
  components: {
    Modal,
    ModalTitle,
    ModalContentBody,
    DangerAlert,
    PrefectureSelect,
    ModalFooter,
    FilterButton,
    ResetButton,
    CancelButton,
  },
  data() {
    return {
      name: '',
      name_kana: '',
      prefecture_code: null,
      address1: '',
      dataNotFound: false,
      errors: {},
    }
  },
  methods: {
    show() {
      this.dataNotFound = false;
      this.errors = {};

      this.$refs.modal.show();
    },
    setPrefecture(payload) {
      let parsed = parseInt(payload.value);
      this.prefecture_code = isNaN(parsed) ? null : parsed;
    },
    doFilter() {
      this.dataNotFound = false;
      this.errors = {};

      this.$store.dispatch('issuance_request_form/loadBuildings', {
        management_company_code : localStorage.getItem('managementCompanyCode'),
        name: this.name,
        name_kana: this.name_kana,
        prefecture_code: this.prefecture_code,
        address1: this.address1,
        is_guest: this.$store.state.account.is_guest
      }).then(() => {
        this.$refs.modal.hide();
      }).catch(reason => {
        if (reason?.notFound) {
          this.dataNotFound = true;
        } else if (reason?.errors) {
          this.errors = reason.errors;
        } else {
          this.$root.failApi(reason);
        }
      })
    },
    doReset() {
      this.name = '';
      this.name_kana = '';
      this.prefecture_code = null;
      this.address1 = '';
      this.dataNotFound = false;
      this.errors = {};
    },
  },
}
</script>